export default "__VITE_ASSET__CFSAd5_v__"